import(/* webpackMode: "eager" */ "/app/assets/images/social-markup/default-social.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layouts/Application.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useStoryblokState"] */ "/app/node_modules/.pnpm/@storyblok+react@5.4.0_next@15.4.7_react-dom@18.3.1_react@18.3.1/node_modules/@storyblok/react/dist/core/use-storyblok-state.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.4.7_react-dom@18.3.1_react@18.3.1_sass@1.89.2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.7_react-dom@18.3.1_react@18.3.1_sass@1.89.2/node_modules/next/dist/client/image-component.js");
